<template>
  <LogsTable />
</template>

<script>
import LogsTable from "./LogsTable.vue";

export default {
  components: {
    LogsTable,
  },
  props: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
  watch: {},
  computed: {},
};
</script>
